import React from 'react'
import PropTypes from 'prop-types'
import { connect } from 'react-redux'
import { bindActionCreators } from 'redux'
import { createStructuredSelector } from 'reselect'
import styled from 'styled-components'
import html2canvas from 'html2canvas'
import jsPDF from 'jspdf'
import get from 'lodash/get'
import find from 'lodash/find'
import set from 'lodash/set'
import { css } from '@emotion/core'
import { BeatLoader } from 'react-spinners'
import {
  Button,
  Label,
  UncontrolledDropdown,
  DropdownToggle,
  DropdownMenu,
  DropdownItem,
} from 'reactstrap'
import { timesheetAction, lobAction } from '../../../../actions'
import { timesheetSelector, lobSelector } from '../../../../selectors'
import { CancelTimesheetForm } from '../../form/cancel-timesheet'
import ExportByProjectForm from '../../form/export-timesheet-by-project'
import ExportByLOBForm from '../../form/export-timesheet-by-lob'
import * as timesheetHelper from '../../helpers/timesheet'
import SearchIcon from "../../../../static/images/search_icon.svg"
import { FONTS } from '../../../../constants'
import moment from '../../../../lib/moment.js'

const TimesheetStatusButton = class extends React.Component {
  static getDerivedStateFromProps(nextProps, prevState) {
    const tempState = prevState
    if (get(nextProps, 'getLOBData')) {
      const lobList = timesheetHelper.createLOBList(get(nextProps, 'getLOBData'))
      set(tempState, 'lobList', lobList)
      nextProps.resetGetLOB()
    }
    if (get(nextProps, 'projects')
    && get(nextProps, 'authData')
    && prevState.lobList.length !== 0
    && prevState.projectList.length === 0) {
      const lobID = get(nextProps, 'authData.user.lob_id')
      const defaultLOB = find(prevState.lobList, { value: lobID })
      const projectList = timesheetHelper.createProjectList(get(nextProps, 'projects'))
      set(tempState, 'defaultLOB', defaultLOB || [])
      set(tempState, 'projectList', projectList)
      set(tempState, 'selectedLOB', defaultLOB || [])
    }
    if (get(nextProps, 'getExportURL')) {
      window.open(get(nextProps, 'getExportURL'))
      nextProps.resetExportTimesheet()
    }
    if (get(nextProps, 'getExportMyTimesheetURL')) {
      window.open(get(nextProps, 'getExportMyTimesheetURL'))
      nextProps.resetExportMyTimesheet()
    }
    if (get(nextProps, 'dateStatus') !== prevState.dateStatus) {
      set(tempState, 'dateStatus', get(nextProps, 'dateStatus'))
      set(tempState, 'selectedStartMonth', moment(get(nextProps, 'dateStatus')))
      set(tempState, 'selectedEndMonth', moment(get(nextProps, 'dateStatus')))
    }
    return tempState
  }

  state={
    searchStatus: this.props.searchStatus,
    showCancel: false,
    lobList: [],
    showExport: false,
    selectedProject: [],
    selectedLOB: [],
    projectList: [],
    selectedStartMonth: moment(),
    selectedEndMonth: moment(),
    isFetching: false,
  }

  componentDidMount() {
    this.props.getLOB(localStorage.getItem('access_token'))
  }

  clickCancelButton = (cancel) => {
    const requestID = get(this.props, 'timesheetRequest.timesheetRequest._id')
    if (cancel === 'yes') this.props.cancelTimesheet(requestID, { remark_reject_by_hr: this.state.remark_reject_by_hr })
    this.setState({ showCancel: !this.state.showCancel, remark_reject_by_hr: '' })
  }

  printTimesheet = async () => {
    const timesheetRequest = get(this.props, 'timesheetRequest.timesheetRequest')
    const month = get(timesheetRequest, 'timesheet_snapshot.month')
    const users = get(this.props, 'timesheets.users', [])
    const user = find(users, {
      _id: timesheetRequest.user_id,
    })
    this.setState({ isFetching: !this.state.isFetching })
    const input = document.getElementById('printContainer')
    input.cloneNode(true)
    const pdf = new jsPDF('l', 'mm', 'a4')
    const imgWidth = pdf.internal.pageSize.getWidth() - 10
    const pageHeight = pdf.internal.pageSize.getHeight()
    let position = 20
    let heightLeft = pageHeight
    const imageHeader = []
    const imageHeight = []
    await html2canvas(input.childNodes[0])
      .then(async (canvas) => {
        const imgData = canvas.toDataURL('image/png')
        const imgHeight = (canvas.height * imgWidth) / canvas.width
        imageHeader.push(imgData)
        imageHeight.push(imgHeight)
        pdf.addImage(imgData, 'PNG', 5, 20, imgWidth, imgHeight, '', 'FAST')
        heightLeft -= imgHeight + 20
        position = pageHeight - heightLeft
      })
    await html2canvas(input.childNodes[1])
      .then(async (canvas) => {
        const imgData = canvas.toDataURL('image/png')
        const imgHeight = (canvas.height * imgWidth) / canvas.width
        if (heightLeft - imgHeight < 10) {
          pdf.addPage()
          pdf.addImage(imgData, 'PNG', 5, 20, imgWidth, imgHeight, '', 'FAST')
          heightLeft = pageHeight - (imgHeight + 20)
          position = imgHeight + 20
        } else {
          pdf.addImage(imgData, 'PNG', 5, position, imgWidth, imgHeight, '', 'FAST')
          heightLeft -= imgHeight
          position = pageHeight - heightLeft
        }
      })
    const searchBar = document.getElementById('searchBarTimesheetStatus')
    searchBar.cloneNode(true)
    await html2canvas(searchBar)
      .then(async (canvas) => {
        const imgData = canvas.toDataURL('image/png')
        const imgHeight = (canvas.height * imgWidth) / canvas.width
        imageHeader.push(imgData)
        imageHeight.push(imgHeight)
        if (heightLeft - imgHeight < 10) {
          pdf.addPage()
          pdf.addImage(imgData, 'PNG', 5, 20, imgWidth, imgHeight, '', 'FAST')
          heightLeft = pageHeight - (imgHeight + 20)
          position = imgHeight + 20
        } else {
          pdf.addImage(imgData, 'PNG', 5, position, imgWidth, imgHeight, '', 'FAST')
          heightLeft -= imgHeight
          position = pageHeight - heightLeft
        }
      })
    await html2canvas(input.childNodes[3])
      .then(async (canvas) => {
        const imgData = canvas.toDataURL('image/png')
        const imgHeight = (canvas.height * imgWidth) / canvas.width
        if (heightLeft - imgHeight < 10) {
          pdf.addPage()
          pdf.addImage(imgData, 'PNG', 5, 20, imgWidth, imgHeight, '', 'FAST')
          heightLeft = pageHeight - (imgHeight + 20)
          position = imgHeight + 20
        } else {
          pdf.addImage(imgData, 'PNG', 5, position, imgWidth, imgHeight, '', 'FAST')
          heightLeft -= imgHeight
          position = pageHeight - heightLeft
        }
      })
    const childen = Array.from(input.childNodes[4].childNodes)
    for (let child of childen) {
      const childen2 = Array.from(child.childNodes)
      for (let child2 of childen2) {
        const canvas = await html2canvas(child2)

        const imgData = canvas.toDataURL('image/png')
        const imgHeight = (canvas.height * imgWidth) / canvas.width
        if (heightLeft - imgHeight < 10) {
          pdf.addPage()
          pdf.addImage(imageHeader[0], 'PNG', 5, 20, imgWidth, imageHeight[0], '', 'FAST')
          pdf.addImage(imageHeader[1], 'PNG', 5, 20 + imageHeight[0], imgWidth, imageHeight[1], '', 'FAST')
          pdf.addImage(imgData, 'PNG', 5, 20 + imageHeight[0] + imageHeight[1], imgWidth, imgHeight, '', 'FAST')
          heightLeft = pageHeight - (imgHeight + 20 + imageHeight[0] + imageHeight[1])
          position = imgHeight + 20 + imageHeight[0] + imageHeight[1]
        } else {
          pdf.addImage(imgData, 'PNG', 5, position, imgWidth, imgHeight, '', 'FAST')
          heightLeft -= imgHeight
          position = pageHeight - heightLeft
        }
      }
    }
    await html2canvas(input.childNodes[5])
      .then(async (canvas) => {
        const imgData = canvas.toDataURL('image/png')
        const imgHeight = (canvas.height * imgWidth) / canvas.width
        if (heightLeft - imgHeight < 10) {
          pdf.addPage()
          pdf.addImage(imgData, 'PNG', 5, 20, imgWidth, imgHeight, '', 'FAST')
          heightLeft = pageHeight - (imgHeight + 20)
          position = imgHeight + 20
        } else {
          pdf.addImage(imgData, 'PNG', 5, position, imgWidth, imgHeight, '', 'FAST')
          heightLeft -= imgHeight
          position = pageHeight - heightLeft
        }
      })
    pdf.setFontSize(10)
    const totalPage = pdf.internal.getNumberOfPages()
    for (let i = 0; i < totalPage; i++) {
      pdf.setPage(i + 1)
      pdf.text(`Page ${i + 1} of ${totalPage}`, pdf.internal.pageSize.width - 25, 15)
    }
    this.setState({ isFetching: !this.state.isFetching })
    pdf.save(`timesheet-${get(user, 'emp_code', '')}-${get(user, 'first_name', '')}-${moment(month).format('MMMM')}-${moment(month).format('YYYY')}-${moment().toString()}.pdf`)
  }

  handleExport = (type) => {
    switch (type) {
      case 'project':
        return this.setState({
          showExportProject: !this.state.showExportProject,
          projectList: [],
          selectedProject: [],
          selectedStartMonth: moment(get(this.props, 'dateStatus')),
          selectedEndMonth: moment(get(this.props, 'dateStatus')),
        })
      case 'lob':
        return this.setState({
          showExportLOB: !this.state.showExportLOB,
          selectedLOB: this.state.defaultLOB,
          selectedStartMonth: moment(get(this.props, 'dateStatus')),
          selectedEndMonth: moment(get(this.props, 'dateStatus')),
        })
      default: return this.setState({
        showExportProject: false,
        showExportLOB: false,
        projectList: [],
      })
    }
  }

  handleInputExport = (type, data) => {
    switch (type) {
      case 'startDate': {
        this.setState({ selectedStartMonth: data })
        break
      }
      case 'endDate': {
        this.setState({ selectedEndMonth: data })
        break
      }
      case 'project': {
        this.setState({ selectedProject: data })
        break
      }
      case 'lob': {
        this.setState({ selectedLOB: data })
        break
      }
      default:
        break
    }
  }

  clickExportButton = (type) => {
    const access_token = localStorage.getItem('access_token')
    const {
      selectedProject,
      selectedLOB,
      selectedStartMonth,
      selectedEndMonth,
    } = this.state
    switch (type) {
      case 'project': {
        this.props.exportTimesheetByProject(
          selectedProject.value,
          moment(selectedStartMonth).format('YYYY-MM'),
          moment(selectedEndMonth).format('YYYY-MM'),
          access_token
        )
        break
      }
      case 'lob': {
        this.props.exportTimesheetByLOB(
          selectedLOB.value,
          moment(selectedStartMonth).format('YYYY-MM'),
          moment(selectedEndMonth).format('YYYY-MM'),
          access_token
        )
        break
      }
      default: break
    }
    this.handleExport()
    this.setState({ selectedProject: [], selectedLOB: [] })
  }

  render() {
    const { isFetching } = this.state
    const { handleInputTimesheetStatus, projects } = this.props
    const requestID = get(this.props, 'timesheetRequest.timesheetRequest._id')
    const can_cancel = get(this.props, 'timesheetRequest.timesheetRequest.can_cancel')
    const dateStatus = get(this.props, 'dateStatus')

    const projectList = timesheetHelper.createProjectList(projects)
    const IsAdminUser = get(this.props, 'authData.user.is_hr_admin_role')
    const IsSystemUser = get(this.props, 'authData.user.is_system_admin')
    const IsHRConfidentialUser = get(this.props, 'authData.user.is_hr_admin_confidential_role')
    const IsManagementUser = get(this.props, 'authData.user.is_management_role')
    const IsLOBLeadUser = get(this.props, 'authData.user.is_lob_lead_role')
    const IsAccountantUser = get(this.props, 'authData.user.is_accountant_role')
    const canExportByLOB = (IsAdminUser
      || IsSystemUser
      || IsHRConfidentialUser
      || IsManagementUser
      || IsAccountantUser)

    if (get(this.props, 'location') === `/time_sheet/status/${get(this.props, 'path')}`) {
      return (
        <Wrapper>
          { isFetching &&
          <Overlay>
            <OverlayWrapper>
              <BeatLoader
                css={ css(`
                  position: absolute;
                  left: 50%;
                  top: 50%;
                `) }
                sizeUnit={ "px" }
                size={ 15 }
                color={ '#D44B49' }
                loading={ isFetching }
              />
            </OverlayWrapper>
          </Overlay>
          }
          <Dropdown>
            <ItemDropdown>
              Export
            </ItemDropdown>
            <DropdownMenu>
              <DropdownItem
                onClick={ () => this.props.exportMyTimesheet(requestID, localStorage.getItem('access_token')) }
              >CSV</DropdownItem>
              <DropdownItem onClick={ () => this.printTimesheet() }>PDF</DropdownItem>
            </DropdownMenu>
          </Dropdown>
          { can_cancel && <CustomButton
            onClick={ () => this.setState({ showCancel: !this.state.showCancel }) }
          >Reject</CustomButton>
          }
          <CancelTimesheetForm
            open={ this.state.showCancel }
            toggle={ () => this.setState({ showCancel: !this.state.showCancel }) }
            clickCancelButton={ this.clickCancelButton }
            handleRemark={ (e) => this.setState({ remark_reject_by_hr: e.target.value }) }
          />
        </Wrapper>
      )
    }
    return (
      <Buttons>
        <SearchField
          placeholder='Search by employee'
          value={ this.state.searchStatus }
          onChange={ (e) => {
            if (e.target.value === '') handleInputTimesheetStatus('searchStatus', '')
            this.setState({ searchStatus: e.target.value })
          } }
          onKeyDown={ (e) => {
            if (e.keyCode === 13) handleInputTimesheetStatus('searchStatus', this.state.searchStatus)
          } }
        />
        <DateGroup>
          <ArrowButton
            background='white'
            onClick={ () => handleInputTimesheetStatus('dateStatus', moment(dateStatus.add(-1, 'month'))) }
          >&#65308;</ArrowButton>
          <LabelMonth>{ dateStatus ? `${dateStatus.format('MMM')} ${dateStatus.format('YYYY')}` : ''}</LabelMonth>
          <ArrowButton
            background='white'
            onClick={ () => handleInputTimesheetStatus('dateStatus', moment(dateStatus.add(1, 'month'))) }
          >&#65310;</ArrowButton>
        </DateGroup>
        <ExportLabel>Export By:</ExportLabel>
        <ExportButton onClick={ () => this.handleExport('project') }>
          <ExportWrapper>
          Project
          </ExportWrapper>
        </ExportButton>
        { (canExportByLOB || IsLOBLeadUser) &&
        <ExportButton onClick={ () => this.handleExport('lob') }>
          <ExportWrapper>
          LOB
          </ExportWrapper>
        </ExportButton>
        }
        <ExportByProjectForm
          selectedProject={ this.state.selectedProject }
          selectedStartMonth={ this.state.selectedStartMonth }
          selectedEndMonth={ this.state.selectedEndMonth }
          projectList={ projectList }
          open={ this.state.showExportProject }
          toggle={ this.handleExport }
          handleInputExport={ this.handleInputExport }
          clickExportButton={ () => this.clickExportButton('project') }
        />
        <ExportByLOBForm
          selectedLOB={ this.state.selectedLOB }
          selectedStartMonth={ this.state.selectedStartMonth }
          selectedEndMonth={ this.state.selectedEndMonth }
          lobList={ this.state.lobList }
          open={ this.state.showExportLOB }
          toggle={ this.handleExport }
          handleInputExport={ this.handleInputExport }
          clickExportButton={ () => this.clickExportButton('lob') }
        />
      </Buttons>
    )
  }
}

TimesheetStatusButton.propTypes = {
  handleInputTimesheetStatus: PropTypes.func.isRequired,
  cancelTimesheet: PropTypes.func,
  exportMyTimesheet: PropTypes.func,
  searchStatus: PropTypes.string,
  exportTimesheetByProject: PropTypes.func.isRequired,
  exportTimesheetByLOB: PropTypes.func.isRequired,
  getLOB: PropTypes.func.isRequired,
  projects: PropTypes.array,
}
TimesheetStatusButton.defaultProps = {
  cancelTimesheet: () => {},
  exportMyTimesheet: () => {},
  searchStatus: '',
  projects: [],
}

const mapStateToProps = (state, props) => createStructuredSelector({
  getExportMyTimesheetURL: timesheetSelector.getExportMyTimesheetURL,
  getExportURL: timesheetSelector.getExportURL,
  getLOBData: lobSelector.getListLOB,
})(state, props)
const mapDispatchToProps = dispatch => bindActionCreators({
  exportTimesheetByProject: timesheetAction.exportTimesheetByProject,
  exportTimesheetByLOB: timesheetAction.exportTimesheetByLOB,
  resetExportTimesheet: timesheetAction.resetExportTimesheet,
  exportMyTimesheet: timesheetAction.exportMyTimesheet,
  resetExportMyTimesheet: timesheetAction.resetExportMyTimesheet,
  getLOB: lobAction.getLOB,
  resetGetLOB: lobAction.resetListLOB,
}, dispatch)

export default connect(mapStateToProps, mapDispatchToProps)(TimesheetStatusButton)

const ExportLabel = styled(Label)`
  margin: 10px;
  font-size: 12px;
  width: 70px;
`
const Wrapper = styled.div`
  display: flex;
  flex-direction: row;
  height: 30px;
  border: none;
`
const Buttons = styled.div`
  justify-content: flex-end;
  position: absolute;
  display: flex;
  right: 10px;
  height: 40px;
  align-items: center;
`
const SearchField = styled.input`
  width : 220px;
  height: 30px;
  padding-left: 30px;
  background: url(${SearchIcon}) no-repeat scroll 5%;
  background-size: 15px 15px;
  font-family: ${FONTS.GOTHAM} !important;
  font-size: ${FONTS.SMALL_SIZE};
  border: 1px solid #ccc;
  border-radius: 4px;
  margin-left: 2% !important;
  margin-right: 10px;
  margin-top: auto;
  margin-bottom: auto;
  -o-text-overflow: ellipsis;
  -ms-text-overflow: ellipsis;
  text-overflow: ellipsis;
  ::placeholder {
    color: #CCCCCC;
    font-size: 12px;
  }
`
const CustomButton = styled(Button)`
  margin-right: 10px ;
  font-family: ${FONTS.GOTHAM_MEDIUM} !important;
  font-size: ${FONTS.SMALL_SIZE};
`
const ExportButton = styled.button`
  font-family: ${FONTS.GOTHAM_MEDIUM};
  font-size: ${FONTS.SMALL_SIZE};
  background-color: #428BCA;
  width: 80px;
  height: 30px;
  margin-right: 10px;
  color: white;
  border-color: #428BCA;
  border-radius: 4px;
  cursor: pointer;
  float: right;
  padding-bottom: 0px !important;
  &:hover {
    background-color: #333333;
    color: #ffffff;
    border-color: #CCCCCC ;
    }
`
const ItemDropdown = styled(DropdownToggle)`
  background-color: #428BCA;
  font-family: ${FONTS.GOTHAM_MEDIUM};
  font-size: ${FONTS.SMALL_SIZE};
  border:none;
  &:hover{
    background-color: #428BCA;
  }
`
const Dropdown = styled(UncontrolledDropdown)`
  border-radius: 50%;
  font-family: ${FONTS.GOTHAM_MEDIUM};
  font-size: ${FONTS.SMALL_SIZE};
  background-color: white;
  margin-right: 10px;
  .btn:not(:disabled):not(.disabled) {
    cursor: pointer;
    height: 100%;
  }
`
const Overlay = styled.div`
  position: fixed;
  top: 0;
  left: 0;
  bottom: 0;
  right: 0;
`
const OverlayWrapper = styled.div`
  width: 100%;
  height: 100%;
  position: relative;
`
const ExportWrapper = styled.div`
  height: 100%;
  font-size: ${FONTS.SMALL_SIZE};
  display: flex;
  flex-direction: row;
  justify-content: center;
  align-items: center;
`
const DateGroup = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: flex-end;
  margin-top: auto;
  margin-bottom: auto;
`
const NavBarButton = styled(Button)`
  height: 30px;
  width: 70px;
  font-size: 12px;
  margin-left: 2px;
  margin-right: 2px;
  padding: 0px;
  text-align: center;
  background: ${(props) => { return props.background }};
  color: ${(props) => { return props.color }};
  border: 1px solid #E6E6E6;
`
const ArrowButton = styled(NavBarButton)`
  width: 30px;
  color: black;
  font-size: 12px;
  border: 1px solid #E6E6E6;
`
const LabelMonth = styled.label`
  width: 70px;
  font-size: ${FONTS.SMALL_SIZE};
  margin-top: auto;
  margin-bottom: auto;
  text-align: center;
  font-family: ${FONTS.GOTHAM_MEDIUM} !important;
`



// WEBPACK FOOTER //
// ./src/components/timesheet/tab/button-group/timesheet-status-button.js